import { apiSlice } from "app/api/apiSlice"

export const aiLogApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompanyAiLog: builder.query({
            query: ({ pageNumber = 0, pageSize = 15 }) => ({
                url: 'ai/log',
                params: { pageNumber, pageSize },
            }),
            keepUnusedDataFor: 5,
        }),
    }),

})

export const {
    useGetCompanyAiLogQuery,
} = aiLogApiSlice